import { createSlice } from "@reduxjs/toolkit"
import { changePassword, checkSession, getProfile, login, updateProfile } from "../actions/auth"

const INITIAL_STATE = {
    isLoading: false,
    isError: false,
    profileData: {},
}

export const authSlice = createSlice({
    name: "auth",
    initialState: INITIAL_STATE,
    extraReducers: (builder) => {


        builder.addCase(login.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(login.fulfilled, (state, action) => {
            state.isLoading = false;
        });
        builder.addCase(login.rejected, (state) => {
            state.isError = true;
        });


        builder.addCase(getProfile.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getProfile.fulfilled, (state, action) => {
            state.isLoading = false;
            const { payload } = action;
            state.profileData = payload.data?.user
        });
        builder.addCase(getProfile.rejected, (state) => {
            state.isError = true;
        });

        builder.addCase(changePassword.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(changePassword.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(changePassword.rejected, (state) => {
            state.isError = true;
        });

        //==============================
        //update user profile
        //=============================
        builder.addCase(updateProfile.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateProfile.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(updateProfile.rejected, (state) => {
            state.isError = true;
        });

        builder.addCase(checkSession.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(checkSession.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sessionData = action.payload.data?.user
        });
        builder.addCase(checkSession.rejected, (state) => {
            state.isError = true;
        });
    }
})

export default authSlice.reducer;